module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAYAAACoYAD2AAABbklEQVRYhe2XPUrEUBRGzzgZVFC0sLAQrKy0sHAJNi7BzsYF2FgpCJYWLsAduAQ3IYJiI1PYaakgzDjjlTskMIx5yks+JeA7EEjuC19OSN4fZqY8zsysa2bXZrarylUKXtpXdhTZrZFpfdaB25KUG2CzbvqUwhBYDdQXFOEqyX6g3lOEqyRD/4zkX1JJ/ipJUkWSVJEkVSRJFf9K8jlQHyjCs7HzeWAFaAEfERkushVomwbWgHYFrzeg6xfFevIc2AMWI8N+wvKXrsoDcOySp8CRWE6KSw4qfI6/pOcd57XBgk7mkocNEPmOtveiC6AD7APLec+OWVH7/bPAUklbPx+eYjtPOx817oGTyd1iJxeMldwGrkra/CEbFST9Cw+LoTCbaHyPDCt4CdQtcswtGI5fqGacuUBdkp8WGCqSpIokqSJJqkiSKlSSoZxGTYuTC5WCGUW4SvIuUB/t9uqiknwEfEPnW5HieAIOaicDn1paO71H9Nh0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/more.png
// module id = zawa
// module chunks = 0